import { SavedShipmentResponseDataDTO, SealineNameDTO } from "./response.types";
import { SeaReferenceTypesDTO, ShipmentStatusesDTO } from "entities/shared/seaCard.types";
import { CoordinateModelDTO, DateTimeDTO, SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

export class SavedShipmentResponseParser {
  constructor(private model: SavedShipmentResponseDataDTO) {}

  get id(): number {
    return this.model.id;
  }

  get reference(): SearchReferenceDTO | null {
    return this.model.reference ?? null;
  }

  get referenceType(): ValueOf<typeof SeaReferenceTypesDTO> | null {
    return this.model.type ?? null;
  }

  get containersAmount(): number {
    return this.model.equipments_count;
  }

  get status(): ValueOf<typeof ShipmentStatusesDTO> | null {
    return this.model.status;
  }

  get carrierName(): SealineNameDTO | null {
    return this.model.carrier_name;
  }

  get carrierScac(): SealineNameDTO | null {
    return this.model.carrier_scac;
  }

  get fromDirection(): string | null {
    return this.model.location.from;
  }

  get toDirection(): string | null {
    return this.model.location.to;
  }

  get snapshotCreatedAt(): string | null {
    return this.model.snapshot_created_at;
  }

  get updatedAt(): string {
    return this.model.updated_at;
  }

  get currentPin(): CoordinateModelDTO | null {
    return this.model.location.pin;
  }

  get atd(): DateTimeDTO | null {
    return this.model.date.from_actual === true && this.model.date.from ? this.model.date.from : null;
  }

  get etd(): DateTimeDTO | null {
    return this.model.date.from_actual === false && this.model.date.from ? this.model.date.from : null;
  }

  get ata(): DateTimeDTO | null {
    return this.model.date.to_actual === true && this.model.date.to ? this.model.date.to : null;
  }

  get eta(): DateTimeDTO | null {
    return this.model.date.to_actual === false && this.model.date.to ? this.model.date.to : null;
  }

  get tags(): string[] {
    return this.model.tags;
  }

  get predictiveETA(): DateTimeDTO | null {
    return this.model.date?.to_predictive ?? null;
  }

  get containersSizeTypes(): string[] {
    if (!this.model?.size_type) return [];
    try {
      return JSON.parse(this.model.size_type) as string[];
    } catch (error) {
      return [];
    }
  }
}
